<template>
  <div>
    <BackButton class="mb-5"></BackButton>
    <div class="row">
      <div class="col-xl-6">
        <card class="card" title="Update Application Form">
          <p-button
            class="modalCustom__header-deleteButton"
            type="danger"
            @click.prevent.native="destroy"
            round
            outline
            icon
          >
            <i class="fas fa-trash" />
          </p-button>
          <div v-if="loading">
            <MoonLoader class="loading"></MoonLoader>
          </div>
          <div v-else>
            <div class="row">
              <div class="col">
                <fg-input
                  type="text"
                  label="Application name *"
                  placeholder="Example golf club website"
                  v-model="client.name"
                >
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <fg-input
                  type="text"
                  label="Homepage URL *"
                  placeholder="https://your-website-url.com"
                  v-model="client.redirect"
                >
                </fg-input>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col text-right">
              <p-button type="success" :loading="saving" @click.prevent.native="save()"> Save </p-button>
            </div>
          </div>
        </card>
      </div>
      <div class="col-xl-6">
        <card class="card" title="Frontend Configuration">
          <p class="mb-10">
            Pass this code to your frontend application code and replace {YOUR_ACCESS_TOKEN} with your generated token
            or <a href="#" @click="openModal()">generate a new one.</a>
          </p>
          <div class="code" @click="copyText(IframeExample)">
            <pre><code>  &lt;<span class="hljs-selector-tag">iframe</span> <span class="hljs-attribute">src</span>=<span class="hljs-string">"https://vivid-leaf.net/api/public/dashboard?&amp;access_token=<span class="highlight">{YOUR_ACCESS_TOKEN}</span>"</span> <span class="hljs-attribute">width</span>=<span class="hljs-string">"100%"</span> <span class="hljs-attribute">height</span>=<span class="hljs-string">"1000"</span> <span class="hljs-attribute">seamless</span>&gt;<span class="hljs-selector-tag">&lt;/iframe&gt;  </span>
            </code></pre>
          </div>
          <p class="mt-10">
            After that you will be able to access your Vivid Leaf Dashboard via your Application. By any questions
            please contact our support team.
          </p>
        </card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <Tokens ref="tokens" :tokens="client.tokens" :client="client" :public_scopes="scopes"></Tokens>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from '@/components/buttons/BackButton';
import CustomClientController from '@/controllers/PublicData/CustomClientController';
import Tokens from '@/components/Application/Tokens';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import GenerateDashboardTokenController from '@/controllers/PublicData/GenerateDashboardTokenController';
import PublicDataScopesController from '@/controllers/PublicData/PublicDataScopesController';
export default {
  name: 'ShowApplication',
  components: { MoonLoader, Tokens, BackButton },
  data() {
    return {
      client_id: null,
      loading: false,
      client: null,
      saving: false,
      scopes: [],
    };
  },
  computed: {
    IframeExample() {
      return (
        '<iframe src="https://vivid-leaf.net/api/public/dashboard?&access_token={YOUR_ACCESS_TOKEN}" width="100%" height="1000" seamless>\n' +
        '</iframe>'
      );
    },
  },
  async mounted() {
    this.loading = true;
    await this.setClient();
    await this.getPublicScopes();
    this.loading = false;
  },
  methods: {
    async setClient() {
      this.client_id = this.$route.params.client_id;
      this.client = await CustomClientController.show(this.client_id);
      console.log(this.client_id);
    },
    async save() {
      this.saving = true;
      try {
        this.client = await CustomClientController.update(this.client_id, this.client);
        this.$notify({
          type: 'success',
          title: 'Application was updated!',
        });
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.saving = false;
    },
    async destroy() {
      try {
        if (confirm('Are you sure, you want to delete this application?')) {
          await CustomClientController.destroy(this.client.id);
          await this.$router.push({ name: 'Applications' });
          this.$notify({
            type: 'success',
            title: 'Application was deleted!',
          });
          await this.$router.push(-1);
        }
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
    copyText: function (code) {
      let vm = this;
      this.$copyText(code).then(
        function (e) {
          vm.$notify({
            type: 'success',
            title: 'Code was copied!',
          });
        },
        function (e) {
          vm.$notify({
            type: 'danger',
            title: 'Can not copy',
          });
        }
      );
    },
    openModal() {
      this.$refs.tokens.openGenerateModal();
    },
    async getPublicScopes() {
      this.scopes = await PublicDataScopesController.index();
    },
  },
};
</script>

<style scoped>
.hljs-selector-tag {
  color: #3b78e7;
}
.hljs-string {
  color: #0d904f;
}
.hljs-attribute {
  color: #9c27b0;
}

.highlight {
  color: goldenrod;
}

.code {
  padding-top: 1.5rem;
  border-radius: 5px;
  background-color: #f1f3f4;
  cursor: pointer;
}
code {
  font-size: 1.3rem;
}
</style>
